// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Footer_navbar__34jWQ","footer_bottom":"Footer_footer_bottom__2Gxwx","footer_top":"Footer_footer_top__d4EiL","icon":"Footer_icon__2QM6i"};